import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- intentionally empty for now, extended later
export interface ContainerContextValue {}

export const ContainerContext = createContext<ContainerContextValue | undefined>(
  undefined,
);
